import { CART_BASE, CART_ITEM } from 'bento-ordering/cart/constants/paths';
import EditCartItemRouteContainer from 'bento-ordering/cart/containers/EditCartItemRouteContainer';
import MenuItemPageLayout from 'bento-ordering/menus/layouts/MenuItemLayout';
import CartRouteContainer from 'bento-ordering/cart/containers/CartRouteContainer';
import CartPageLayout from 'bento-ordering/cart/layouts/CartPageLayout';

const routes = [
  {
    path: CART_BASE,
    exact: true,
    Component: CartRouteContainer,
    Layout: CartPageLayout
  },
  {
    path: CART_ITEM,
    exact: true,
    Component: EditCartItemRouteContainer,
    Layout: MenuItemPageLayout
  }
];

export default routes;
